import { useAppSelector } from 'hooks';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'redux/store';
import { LocaleType } from 'types/constants/locale';
import { LoginUser } from 'types/model/user';
import { userReadQuery } from './user-read.selector';
import { userReadActions } from './user-read.slice';

export const useUserReadFacade = () => {
  const dispatch: AppDispatch = useDispatch();

  /** ロード済みか */
  const loaded: boolean = useAppSelector(userReadQuery.getLoaded);
  /** ユーザー情報 */
  const user: LoginUser = useAppSelector(userReadQuery.getUser);
  /** ロケール */
  const locale: LocaleType = useAppSelector(userReadQuery.getLocale);
  /** 表示用のロケール、LocaleTypeのロケール以外に返されるため、string型  */
  const displayLocale: string = useAppSelector(userReadQuery.getDisplayLocale);
  /** ユーザー名 */
  const userName: string = useAppSelector(userReadQuery.getUserName);
  /** 所属企業名 */
  const companyName: string = useAppSelector(userReadQuery.getCompanyName);
  /** ログイン済みか */
  const loggedIn: boolean = useAppSelector(userReadQuery.getLoggedIn);
  /** IDトークン */
  const idToken: string = useAppSelector(userReadQuery.getIdToken);
  /** リフレッシュトークン */
  const refreshToken: string = useAppSelector(userReadQuery.getrRefreshToken);
  /** リフレッシュインターバル */
  const refreshInterval: number = useAppSelector(userReadQuery.getrRefreshInterval);
  /** プロジェクト招待サービス認可 */
  const isProjectInvitationServiceAuth: boolean = useAppSelector(userReadQuery.isProjectInvitationServiceAuth);
  /** グループ管理サービス認可 */
  const isGroupManagerServiceAuth: boolean = useAppSelector(userReadQuery.isGroupManagerServiceAuth);

  /** ユーザー情報セット */
  const setUser = useCallback(
    (loginUser: LoginUser) => dispatch(userReadActions.setUserInfo(loginUser)),
    [dispatch],
  );
  /** アクセストークンセット */
  const setAccessToken = useCallback(
    (accessToken: string) => dispatch(userReadActions.setAccessToken(accessToken)),
    [dispatch],
  );
  /** リフレッシュトークンセット */
  const setRefreshToken = useCallback(
    (token: string) => dispatch(userReadActions.setRefreshToken(token)),
    [dispatch],
  );
  /** トークンリフレッシュのインターバル(ミリ秒) */
  const setRefreshInterval = useCallback(
    (interval: number) => dispatch(userReadActions.setRefreshInterval(interval)),
    [dispatch],
  );
  /** IDトークンセット */
  const setIdToken = useCallback(
    (_idToken: string) => dispatch(userReadActions.setIdToken(_idToken)),
    [dispatch],
  );

  return {
    loaded,
    user,
    locale,
    displayLocale,
    userName,
    companyName,
    loggedIn,
    idToken,
    refreshToken,
    refreshInterval,
    isProjectInvitationServiceAuth,
    isGroupManagerServiceAuth,
    setUser,
    setAccessToken,
    setRefreshToken,
    setRefreshInterval,
    setIdToken,
  };
};
